module.exports = __webpack_public_path__ + "e602a907e1228d0fc75e6278e916e13d.svg";